import React from 'react'

const OutOfStackTag = () => {
  return (
    <div className='w-fit px-2 py-1 font-size-12px rounded-full bg-red-400 text-white flex items-center justify-center gap-1 pointer-events-none'>
        Out of Stock
    </div>
  )
}

export default OutOfStackTag